import { triggerEvent } from './functions';

/**
 * Add qty + and - to quantity input boxes
 */
document.addEventListener( 'click', ( event ) => {
	const { target } = event;
	if ( target && ( target.matches( '.qty-up' ) || target.matches( '.qty-down' ) ) ) {
		const qtyInput = target.parentNode.querySelector( 'input.qty' );
		const quantity = parseFloat( qtyInput.value );

		if ( target.matches( '.qty-up' ) ) {
			qtyInput.value = quantity + 1;
		} else if ( target.matches( '.qty-down' ) ) {
			if ( quantity > qtyInput.min ) {
				qtyInput.value = quantity - 1;
			}
		}

		triggerEvent( qtyInput, 'change' );
	}
} );
